import enLang from './entries/en_US';
import arLang from './entries/ar_KW';

const AppLocale = {
    en: enLang,
    ar: arLang,
};

export default AppLocale;